<ng-container *transloco="let t">
  <div class="settings">
    <div class="settings__content">
      <div class="settings__section">
        <div class="lang-title settings__section-title tui-space_bottom-1 tui-space_right-5">
          {{ t('settings.interfaceLanguage') }} <b>{{language.value}}</b>
        </div>
        <tui-badged-content class="tui-space_bottom-1 control-select-lang">
          <img alt="" size="s" tuiBadge tuiSlot="bottom"
            [src]="flags.get(language.value ?? '') || flags.get(switcher.language) | tuiFlag" />

          <button appearance="outline-grayscale" size="s" tuiButtonSelect tuiIconButton type="button" [formControl]="language"
            [iconStart]="icons.languages">
            <tui-data-list class="control-select-lang_list" *tuiTextfieldDropdown>
              <tui-opt-group class="control-select-lang_group" label="">
                <button class="control-select-lang_btn" *ngFor="let lang of LANGUAGES" tuiOption type="button"
                  [value]="lang.title| titlecase" (click)="setLang(lang)">
                  <img alt="" class="t-flag control-select-lang_btn_img" [src]="flags.get(lang.title) | tuiFlag" />
                  {{ lang.title| titlecase }}
                </button>
              </tui-opt-group>
            </tui-data-list>
          </button>
        </tui-badged-content>
      </div>
      <div class="settings__section">
        <p class="settings__disclaimer tui-space_top-5 tui-space_bottom-4">
          {{ t('settings.disclaimer') }}
        </p>
        <div class="settings__docs tui-space_bottom-4">
          <a [href]="privacyPolicyUrl" target="_blank" rel="noopener">
            {{ t('settings.privacyPolicy') }}
          </a>
          <a [href]="termsOfServiceUrl" target="_blank" rel="noopener">
            {{ t('settings.termsOfService') }}
          </a>
        </div>
      </div>
      <div class="settings__section">
        <button
          class="settings__support-open-button tui-space_top-2 tui-space_bottom-4"
          tuiButton
          appearance="outline"
          size="m"
          type="button"
          (click)="supportWithOneStar()"
        >
          {{ t('settings.supportCustomButton') }}
        </button>

        <img
          class="settings__support-image tui-space_top-4 tui-space_bottom-2"
          src="https://s3.twcstorage.ru/33f8d173-08e7b2f5-4e26-4769-93a3-ef36294ea243/app/main/happy_dev.jpeg"
          alt="Happy developer"
        />
        <p class="tui-space_top-3">
          {{ t('settings.supportText') }} <a href="mailto:team@my3ego.ru" target="_blank">{{ t('settings.writeToUs') }}</a>
        </p>
        
      </div>
    </div>
  </div>

  <ng-template #telegramNoticeTemplate="polymorpheus" polymorpheus>
    <p class="settings__support-notification-text">
      {{ t('settings.supportTelegramOnly') }}
    </p>
    <div class="tui-space_top-2">
      <button
        tuiButton
        size="s"
        type="button"
        (click)="openTelegramBot()"
      >
        {{ t('settings.supportOpenButton') }}
      </button>
    </div>
  </ng-template>
</ng-container>